import * as reduxModule from 'redux';
import { applyMiddleware, compose, createStore } from 'redux';
import { createLogger } from "redux-logger";
import thunk from 'redux-thunk';
import createReducer from './reducers';

reduxModule.__DO_NOT_USE__ActionTypes.REPLACE = '@@redux/INIT';

const composeEnhancers = 
 	process.env.NODE_ENV !== 'production' && typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
 		? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
 			// Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
 		})
 		: compose;
const enhancer = composeEnhancers(applyMiddleware(thunk));

const middlewares = [thunk.withExtraArgument()];
if (process.env.NODE_ENV !== "production") {
	middlewares.push(
		createLogger({
			colors: {
				title: () => "inherit",
				prevState: () => "red",
				action: () => "#03A9F4",
				nextState: () => "#4CAF50",
				error: () => "#F20404"
			}
		})
	);
}

const store = process.env.REACT_APP_REDUX_LOGGER === "true" ? createStore(createReducer, applyMiddleware(...middlewares)) : createStore(createReducer(), enhancer);

store.asyncReducers = {};

export const injectReducer = (key, reducer) => {
	if (store.asyncReducers[key]) {
		return false;
	}
	store.asyncReducers[key] = reducer;
	store.replaceReducer(createReducer(store.asyncReducers));
	return store;
};
export default store;